/* ── Prevent re-adding items already in the cart via quick-add ── */
(function () {
  var IN_CART_CLASS = 'quick-add--in-cart';
  var IN_CART_LABEL_CLASS = 'qa-in-cart-label';
  var IN_CART_TEXT = 'הפריט כבר בעגלת הקניות';

  var cartVariantIds = new Set();

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartVariantIds = new Set(cart.items.map(function (item) {
          return String(item.variant_id);
        }));
        syncAllQuickAdds();
      })
      .catch(function () {});
  }

  function syncAllQuickAdds() {
    document.querySelectorAll('quick-add-component').forEach(syncOne);
  }

  function syncOne(qa) {
    var variantInput = qa.querySelector('input[name="id"]');
    if (!variantInput) return;

    var inCart = cartVariantIds.has(variantInput.value);

    qa.querySelectorAll('button').forEach(function (btn) {
      btn.disabled = inCart;
      btn.setAttribute('aria-disabled', inCart ? 'true' : 'false');
      btn.classList.toggle(IN_CART_CLASS, inCart);
    });

    var form = qa.querySelector('form');
    if (form) {
      if (inCart) {
        form.dataset.cartBlocked = '1';
      } else {
        delete form.dataset.cartBlocked;
      }
    }

    var label = qa.querySelector('.' + IN_CART_LABEL_CLASS);
    if (inCart && !label) {
      var el = document.createElement('p');
      el.className = IN_CART_LABEL_CLASS;
      el.setAttribute('dir', 'rtl');
      el.setAttribute('aria-live', 'polite');
      el.textContent = IN_CART_TEXT;
      qa.appendChild(el);
    } else if (!inCart && label) {
      label.remove();
    }
  }

  // Block form submission before Horizon's handler gets it
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.dataset.cartBlocked) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // Block clicks on already-in-cart buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('quick-add-component button');
    if (btn && btn.classList.contains(IN_CART_CLASS)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // Watch for quick-add-components added to DOM after page load (AJAX sections)
  var observer = new MutationObserver(function (mutations) {
    var found = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('quick-add-component')) {
          syncOne(node);
          found = true;
        } else if (node.querySelectorAll) {
          var children = node.querySelectorAll('quick-add-component');
          if (children.length) {
            children.forEach(syncOne);
            found = true;
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', fetchCart);
  document.addEventListener('cart:updated', fetchCart);
  document.addEventListener('cart:refresh', fetchCart);
})();

/* ── Locale-aware internal link routing ── */
(function () {
  function getActiveLocale() {
    var path = window.location.pathname || '/';
    return path === '/en' || path.indexOf('/en/') === 0 ? 'en' : 'he';
  }

  function getInternalUrl(href) {
    if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript|data):/i.test(href)) return null;

    try {
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      return url;
    } catch (error) {
      return null;
    }
  }

  function normalizeLocalePath(path, locale) {
    var normalized = path || '/';

    // Remove an English prefix first so links configured as /en/... also work in Hebrew.
    if (normalized === '/en') {
      normalized = '/';
    } else if (normalized.indexOf('/en/') === 0) {
      normalized = normalized.slice(3) || '/';
    }

    // English storefront uses /en; Hebrew is the primary unprefixed locale.
    if (locale === 'en') {
      return normalized === '/'
        ? '/en/'
        : '/en' + (normalized.charAt(0) === '/' ? normalized : '/' + normalized);
    }

    return normalized;
  }

  document.addEventListener('click', function (event) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) return;

    var target = event.target;
    var link = target && target.closest ? target.closest('a[href]') : null;
    if (!link || link.hasAttribute('download')) return;

    var targetAttr = link.getAttribute('target');
    if (targetAttr && targetAttr.toLowerCase() !== '_self') return;

    var url = getInternalUrl(link.getAttribute('href'));
    if (!url) return;

    var normalizedPath = normalizeLocalePath(url.pathname, getActiveLocale());
    if (normalizedPath === url.pathname) return;

    event.preventDefault();
    window.location.assign(normalizedPath + url.search + url.hash);
  }, true);
})();

/* ── Language switcher: flags only, no text ── */
(function () {
  function buildFlagSwitcher(select) {
    var flags = window.glFlags || {};
    var options = Array.from(select.options);

    var container = document.createElement('div');
    container.className = 'gl-flags-only';

    options.forEach(function (opt) {
      var lang = opt.getAttribute('lang') || opt.value;
      var flagUrl = flags[lang];
      if (!flagUrl) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gl-flag-btn' + (opt.selected ? ' gl-flag-btn--active' : '');
      btn.setAttribute('title', opt.textContent.trim());
      btn.setAttribute('aria-label', opt.textContent.trim());

      var img = document.createElement('img');
      img.src = flagUrl;
      img.alt = opt.textContent.trim();
      img.className = 'gl-lang-flag';
      img.width = 26;
      img.height = 18;
      btn.appendChild(img);

      btn.addEventListener('click', function () {
        if (opt.selected) return;
        select.value = lang;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });

      container.appendChild(btn);
    });

    // Hide the native select wrapper, insert flags before it
    var wrapper = select.closest('.language-selector') || select.parentNode;
    wrapper.parentNode.insertBefore(container, wrapper);
    wrapper.style.display = 'none';
  }

  function initFlagSwitchers() {
    document.querySelectorAll('select[name="language_code"]').forEach(buildFlagSwitcher);
  }

  document.addEventListener('DOMContentLoaded', initFlagSwitchers);
})();
